import React from 'react'
import "../css/settingHeadNav.css"
import { useNavigate } from 'react-router-dom'
import { MockMenuData } from './header.type'

type Props = {}

const SettingHeadNav = (props: Props) => {
    const navigate = useNavigate()
    const onClickSetMen = (path:string) => {
        navigate(path)
    }

    return (
        <section className='scl--shn-style-controller'>
            <div className='scl--arr-const-styl-box'>
                {MockMenuData?.map((items) => {
                    const isActive = location.pathname === items.path

                    return (
                        <div
                            className={`scl--btn-shn-sty-const ${isActive ? /* istanbul ignore next */ 'active' : ''}`}
                            key={items.id}
                        >
                            <button
                                className={`scl--inner-btn-shn-styl-const ${isActive ? /* istanbul ignore next */ 'active' : ''}`}
                                onClick={() => onClickSetMen(items.path)}
                            >
                                {items.title}
                            </button>
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default SettingHeadNav